import React from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import { Tabs, Tab } from 'react-bootstrap-tabs';
import { withRouter } from 'react-router-dom';
import ActivityModal from '../activityModal';
import ActionKPITable from '../actionKpiTable';
import ActionPlanTable from '../actionPlanTable';
import { getQuestionnaire } from '../../actions/tabAction.jsx';
import { fetchActivityKpis, searchActivity ,saveVisibilityOnUpdate} from '../../actions/activityAction.jsx';
import { withTheme } from '../../themes/theming';
import { push } from "connected-react-router";
import Evaluation from '../evaluation';
import Reevaluation from '../evaluation/reevaluation.js';
import { getUserDetails } from "../../actions/loginAction";
import './index.css';
import KaizenSection from '../evaluation/components/kaizenSection';
import moment from 'moment';
var I18n = require('react-redux-i18n').I18n;
var baseUrl="/ket/v1/questionnaire/download/";
//var baseUrl="http://localhost:9090/ket/v1/questionnaire/download/";

class ActionPlan extends React.Component {
    constructor(props) {
        super(props);
        
        if (
            this.props.user.userMdl === undefined ||
            this.props.user.userMdl === null ||
            this.props.user.userMdl.expired === undefined ||
            this.props.user.userMdl.expired
        ) {
            // get user Details from token.
            this.props.dispatch(getUserDetails());
        }
        // console.log(JSON.parse(this.props.location.query.selectedActivity).updateViewed);
  
        this.state = {
            selectedRow: {
                activityId: this.props.location.query.selectedActivity.activityId,
                dealerId: "" + this.props.location.query.selectedActivity.dealerId,
                assignee:  this.props.location.query.assignee,
                dealer: "",
                city: "",
                userId: "" + this.props.location.query.selectedActivity.userId,
                toolbox: this.props.location.query.selectedActivity.toolbox,
                toolboxId: this.props.location.query.selectedActivity.toolboxId,
                firstVisit: this.props.location.query.selectedActivity.firstVisit,
                completionOn: this.props.location.query.selectedActivity.completionOn,
                updatedTimestampStr: "",
                createdBy: "",
                status: this.props.location.query.selectedActivity.status,
                reminderOn: "",
                userMdl: "",
                nmscCode: "",
                langCode: "",
                loginId: "",
                updateViewed:JSON.parse(this.props.location.query.selectedActivity).updateViewed,
                kpiUpdated:JSON.parse(this.props.location.query.selectedActivity).kpiUpdated,
                questionnaireUpdated:JSON.parse(this.props.location.query.selectedActivity).questionnaireUpdated,
                actionPlanUpdated:JSON.parse(this.props.location.query.selectedActivity).actionPlanUpdated,
                firstAudit:this.props.location.query.selectedActivity.firstAudit

            },
            translatedStatus: "",
            toolboxKey: null,
            toolboxLocation: "",
            isLoading: false,
            isNmsc: false,
            translateDate:"",
            hasAutoSelectedTab: false
        };
      
        this.viewStatus =this.viewStatus.bind(this);
    }

    

   
    
    componentWillMount() {

        const {activityDetailsData} = this.props;

        if(this.props.user.userMdl?.activeProgram == "NAS"){
            if(activityDetailsData?.firstAudit === "ONGOING" || (activityDetailsData?.firstAudit === "PASSED" || activityDetailsData?.firstAudit === "FAILED" && activityDetailsData?.kaizen !== "ONGOING")) this.setState({ selectedTab: 1 })
            if(activityDetailsData?.kaizen === "ONGOING" || (activityDetailsData?.status === "ONGOING" && activityDetailsData?.kaizen === "COMPLETED") ) this.setState({ selectedTab: 2 })
            if(activityDetailsData?.reAudit === "ONGOING") this.setState({ selectedTab: 3 })
        }
        var isNMSCAdminUser = false;
        if (this.props.user.userMdl.roles !== undefined) {
          var roles = this.props.user.userMdl.roles;
          for (var i = 0; i < roles.length; i++) {
            if (roles[i].toUpperCase().indexOf("KET NMSC ADMIN") !== -1) {
              isNMSCAdminUser = true;
              break;
            }
          }
        }
        this.setState({ isNmsc: isNMSCAdminUser });

        if (
            this.props.user.userMdl === undefined ||
            this.props.user.userMdl === null ||
            this.props.user.userMdl.expired === undefined ||
            this.props.user.userMdl.expired
        ) {
            // get user Details from token.
            this.props.dispatch(getUserDetails());
        }

        var row = JSON.parse(this.props.location.query.selectedActivity);
        // console.log(this.props.user.userMdl);
        // console.log(this.state.selectedRow)
        this.setState({ selectedActivity: row });
        this.props.dispatch(fetchActivityKpis(row.activityId, this.props.user.userMdl.lang, this.props.user.userMdl.nmsc, this.props.user.userMdl.activeProgramID, this.state.selectedRow, this.props.location.query.searchCriteria));  
        // this.props.dispatch(getFileName(row.activityId, row.toolbox, this.props.user.userMdl.nmsc, this.props.user.userMdl.lang));
    
   
    }
    componentDidUpdate(prevProps) {
        const { activityDetailsData , user} = this.props;
    
        if(user.userMdl?.activeProgram == "NAS"){
            if (
                activityDetailsData !== prevProps.activityDetailsData &&
                activityDetailsData &&
                !this.state.hasAutoSelectedTab
            ) {
                const { firstAudit, kaizen, reAudit, status } = activityDetailsData;
        
                let selectedTab = 0;
        
                // Step 1: Prioritize ONGOING status
                if (firstAudit === "ONGOING") {
                    selectedTab = 1;
                    /**Set the status ongoing when click on the launch activity  */
                    if(this.props.user?.userMdl?.roles?.includes("KET TME Admin")){
                        this.setState({ translatedStatus: 'Ongoing' });
                    }
                } else if (kaizen === "ONGOING" || (status === "ONGOING" && kaizen === "COMPLETED" && reAudit !== "ONGOING")) {
                    selectedTab = 2;
                } else if (reAudit === "ONGOING") {
                    selectedTab = 3;
                }
        
                // Step 2: If no ONGOING, fallback to FAILED/PASSED/COMPLETED
                else if (
                    status === "COMPLETED" &&
                    (firstAudit === "PASSED" || firstAudit === "FAILED")
                ) {
                    selectedTab = 2; // Land on the "Kaizen" tab
                }
                else if (firstAudit && ["FAILED", "PASSED"].includes(firstAudit)) {
                    selectedTab = 1;
                } else if (kaizen && kaizen === "COMPLETED") {
                    selectedTab = 2;
                } else if (reAudit && ["FAILED", "PASSED"].includes(reAudit)) {
                    selectedTab = 3;
                }
        
                // Step 3: If all are present and none are ONGOING, default to tab 0
                const allPresent = firstAudit && kaizen && reAudit;
                const noOngoing = firstAudit !== "ONGOING" && kaizen !== "ONGOING" && reAudit !== "ONGOING";
        
                if (allPresent && noOngoing) {
                    selectedTab = 0;
                }
        
                this.setState({ selectedTab, hasAutoSelectedTab: true });
            }
        }
    }
    
    
    

    labelForKpi =()=>{
        console.log(this.props.user.userMdl );
        var tabdetail = I18n.t('tabsDetails.kpi');
        var evidence_class =  this.state.isNmsc===true ?(this.state.selectedRow.updateViewed  && this.state.selectedRow.updateViewed==="Y" && this.state.selectedRow.kpiUpdated==="True") || ( this.state.selectedRow.kpiUpdated==="True") ?"evidenceUploaded":"evidenceNotUploaded":"" ;
        return (<div>{tabdetail}<span className={evidence_class}></span></div>);
    }
    
    labelForQuestionnaire =()=>{
        // console.log(actionPlanUpdated );
          return (<div> {this.props.user.userMdl.businessAreaKey==="TSP"? I18n.t("dashboardElements.FirstAudit"): I18n.t("tabsDetails.questionnaire") }
         <span className={this.state.isNmsc===true ?(this.state.selectedRow.updateViewed  && this.state.selectedRow.updateViewed==="Y" && this.state.selectedRow.questionnaireUpdated==="True") || ( this.state.selectedRow.questionnaireUpdated==="True")  ?"evidenceUploaded":"evidenceNotUploaded":""}></span>
        </div>);
    }
    
    labelForActionPlan =()=>{
        return (<div>{this.props.user.userMdl.businessAreaKey==="TSP"? I18n.t("TopNav.Kaizen") : I18n.t("tabsDetails.actionPlan") }
        <span className={this.state.isNmsc===true ?(this.state.selectedRow.updateViewed  && this.state.selectedRow.updateViewed==="Y" && this.state.selectedRow.actionPlanUpdated==="True") || ( this.state.selectedRow.actionPlanUpdated==="True") ?"evidenceUploaded":"evidenceNotUploaded":""}></span>
        </div>);
    }

    
    labelForKaizen =()=>{
        return (<div>{this.props.user.userMdl.activeProgramNas==="NAS"? I18n.t("tabsDetails.reevaluation") : "" }
        <span></span>
        </div>);
    }


    componentWillReceiveProps(nextProps) {
        this.setState({ fileName: nextProps.fileName });
        if (nextProps.fileName && nextProps.fileName[0] && nextProps.fileName[0].fileName === "NO_LANG") {
            console.log(" ------- Questioner:This user do not have any language.  ------- ");
            this.setState({ fileName: [] });
        }

        if (nextProps.selectedRow) {
            const selectedRow = { ...this.state.selectedRow };
            selectedRow['activityId'] = nextProps.selectedRow.activityId;
            selectedRow['dealerId'] = "" + nextProps.selectedRow.dealerId;
            selectedRow['dealer'] = "" + nextProps.selectedRow.dealer;
            selectedRow['city'] = "" + nextProps.selectedRow.city;
            selectedRow['userId'] = "" + nextProps.selectedRow.assigneeId;
            selectedRow['toolbox'] = nextProps.selectedRow.toolbox;
            selectedRow['toolboxId'] = nextProps.selectedRow.toolboxId;
            selectedRow['firstVisit'] = nextProps.selectedRow.firstVisit;
            selectedRow['completionOn'] = nextProps.selectedRow.completionDateStr;
            selectedRow['status'] = nextProps.selectedRow.status;
            selectedRow['reminderOn'] = nextProps.selectedRow.reminderOnStr;
            selectedRow['createdBy'] = nextProps.selectedRow.createdBy;
            selectedRow['updatedTimestampStr'] = nextProps.selectedRow.updatedTimestampStr;
            // selectedRow['updateViewed'] = nextProps.selectedRow.updateViewed;

            // selectedRow['userMdl'] = this.props.user.userMdl;
            // selectedRow['nmscCode'] = this.props.user.userMdl.nmsc;
            // selectedRow['langCode'] = this.props.user.userMdl.lang;
            // selectedRow['loginId'] = this.props.user.userMdl.username;
            this.setState({toolboxKey: nextProps.selectedRow.toolboxKey, toolboxLocation:nextProps.selectedRow.location})
            this.setState({ selectedRow: selectedRow, translatedStatus: I18n.t(nextProps.selectedRow.status) });

        
        }

        //to update and show status correctly on screen
        /** This is for TSM/LSM */
        if (nextProps.activityDetailsData && nextProps.activityDetailsData.status  && this.props.user?.userMdl?.activeProgram !== "NAS") {
            this.setState({ translatedStatus: I18n.t(nextProps.activityDetailsData.status) });
            if (nextProps.selectedRow && nextProps.selectedRow.completionDateStr) {
                this.setState({translateDate: I18n.t(nextProps.selectedRow.completionDateStr)});
            }
        }

        if (nextProps.activityDetailsData && nextProps.activityDetailsData.status && this.props.user?.userMdl?.activeProgram !== "NAS" ) {
            const completionDate = new Date(nextProps.activityDetailsData.completionOn);
            // Use proper locale mapping for DD/MM/YYYY format
            let locale = 'en-GB'; // Default to British English for DD/MM/YYYY
            if (this.props.user?.userMdl?.lang) {
                const langMap = {
                    'en': 'en-GB',
                    'fr': 'fr-FR', 
                    'de': 'de-DE',
                    'es': 'es-ES',
                    'it': 'it-IT',
                    'pt': 'pt-PT',
                    'nl': 'nl-NL'
                };
                locale = langMap[this.props.user.userMdl.lang] || 'en-GB';
            }
            const formattedDate = completionDate.toLocaleDateString(
                locale,
                { 
                    day: '2-digit', 
                    month: '2-digit', 
                    year: 'numeric',
                    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone 
                }
            );
 
            console.log(nextProps.activityDetailsData.completionOn, "Timezone:", Intl.DateTimeFormat().resolvedOptions().timeZone);
            this.setState({ translatedStatus: I18n.t(nextProps.activityDetailsData.status) });
            this.setState({translateDate: I18n.t(formattedDate)});
        }
        
        /**This is for NAS as we have to update the date */
        if (nextProps.activityDetailsData && nextProps.activityDetailsData.status  && this.props.user?.userMdl?.activeProgram == "NAS") {
            this.setState({ translatedStatus: I18n.t(nextProps.activityDetailsData.status) });
            if (nextProps.selectedRow && nextProps.selectedRow.completionDateStr) {
                this.setState({translateDate: I18n.t(nextProps.selectedRow.completionDateStr)});
            }
        }

        /** Update translateDate when activityDetailsData.completionOn changes after API call */
        if (nextProps.activityDetailsData && nextProps.activityDetailsData.completionOn && 
            this.props.activityDetailsData?.completionOn !== nextProps.activityDetailsData.completionOn) {
            
            console.log("🔄 activityDetailsData completionOn changed:", 
                "Previous:", this.props.activityDetailsData?.completionOn, 
                "New:", nextProps.activityDetailsData.completionOn);
            
            // Handle both initial load (prev undefined) and actual changes
            if (!this.props.activityDetailsData?.completionOn || 
                this.props.activityDetailsData.completionOn !== nextProps.activityDetailsData.completionOn) {
                
                const updatedCompletionDate = new Date(nextProps.activityDetailsData.completionOn);
                // Use proper locale mapping for DD/MM/YYYY format
                let locale = 'en-GB'; // Default to British English for DD/MM/YYYY
                if (this.props.user?.userMdl?.lang) {
                    const langMap = {
                        'en': 'en-GB',
                        'fr': 'fr-FR', 
                        'de': 'de-DE',
                        'es': 'es-ES',
                        'it': 'it-IT',
                        'pt': 'pt-PT',
                        'nl': 'nl-NL'
                    };
                    locale = langMap[this.props.user.userMdl.lang] || 'en-GB';
                }
                const updatedFormattedDate = updatedCompletionDate.toLocaleDateString(
                    locale,
                    { 
                        day: '2-digit', 
                        month: '2-digit', 
                        year: 'numeric',
                        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone 
                    }
                );
                
                this.setState({translateDate: I18n.t(updatedFormattedDate)});
                console.log("✅ Updated translateDate to:", updatedFormattedDate, "for timezone:", Intl.DateTimeFormat().resolvedOptions().timeZone);
            }
        }

        if(this.props.user?.userMdl?.activeProgram == "NAS" && nextProps.activityDetailsData && nextProps.activityDetailsData.status){
            const completionDate = new Date(nextProps.activityDetailsData.completionOn);
            // Use proper locale mapping for DD/MM/YYYY format
            let locale = 'en-GB'; // Default to British English for DD/MM/YYYY
            if (this.props.user?.userMdl?.lang) {
                const langMap = {
                    'en': 'en-GB',
                    'fr': 'fr-FR', 
                    'de': 'de-DE',
                    'es': 'es-ES',
                    'it': 'it-IT',
                    'pt': 'pt-PT',
                    'nl': 'nl-NL'
                };
                locale = langMap[this.props.user.userMdl.lang] || 'en-GB';
            }
            const formattedDate = completionDate.toLocaleDateString(
                locale,
                { 
                    day: '2-digit', 
                    month: '2-digit', 
                    year: 'numeric',
                    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone 
                }
            ); 

            // Check if activityDetailsData.completionOn has changed for NAS program
            // Handle both initial load (prev undefined) and actual changes
            if (!this.props.activityDetailsData?.completionOn || 
                this.props.activityDetailsData.completionOn !== nextProps.activityDetailsData.completionOn) {
                
                console.log("🔄 NAS: activityDetailsData completionOn changed:", 
                    "Previous:", this.props.activityDetailsData?.completionOn, 
                    "New:", nextProps.activityDetailsData.completionOn,
                    "Timezone:", Intl.DateTimeFormat().resolvedOptions().timeZone);
                
                this.setState({
                    translatedStatus: I18n.t(nextProps.activityDetailsData.status),
                    translateDate: I18n.t(formattedDate)
                });
                console.log("✅ NAS: Updated translateDate to:", formattedDate);
                return; // Exit early to avoid duplicate updates
            }

            if(nextProps?.selectedRow?.completionDateStr && nextProps?.selectedRow?.completionDateStr !== formattedDate && (nextProps.activityDetailsData?.status !=="COMPLETED")){
                this.setState({ 
                    translatedStatus: I18n.t(nextProps.activityDetailsData.status),
                    translateDate: nextProps?.selectedRow?.completionDateStr
                  });     
            }
            if(nextProps?.selectedRow?.completionDateStr && nextProps?.selectedRow?.completionDateStr !== formattedDate && (nextProps.activityDetailsData?.status =="COMPLETED")){
                this.setState({ translatedStatus: I18n.t(nextProps.activityDetailsData.status) });
                this.setState({translateDate: I18n.t(formattedDate)});
            }
        }


    }
    selectedTab = (index, label) => {
        this.setState({ selectedTab: index })
    }


    viewStatus = (activityData) =>{
        this.setState({ isLoading: true });
        // console.log(activityData);
        var viewStatusDTO = {
            activityId: activityData.activityId,
            loginId: this.props.user.userMdl.username,
            updateViewed:"Y",
            kpiUpdated:"False",
            questionnaireUpdated:"False",
            actionPlanUpdated :"False",

        }
        this.props.dispatch(saveVisibilityOnUpdate(viewStatusDTO,this.props.location.query.searchCriteria));
        // console.log(...this.state.selectedRow);
        var selectedRow = {...this.state.selectedRow}
        selectedRow.updateViewed = "Y";
        selectedRow.kpiUpdated = "False";
        selectedRow.questionnaireUpdated = "False";
        selectedRow.actionPlanUpdated = "False";
        this.setState({selectedRow})
        
    }

    getQuestionnaire(filePath) {
        var row = JSON.parse(this.props.location.query.selectedActivity);
        this.setState({ selectedActivity: row });
        this.props.dispatch(getQuestionnaire(filePath))
    }




    toggleModal = (action) => {
        this.setState({
            modal: !this.state.modal,
            modalFor: action,
            selectedRow: {
                activityId: this.state.selectedRow.activityId,
                dealerId: "" + this.state.selectedRow.dealerId,
                dealer: this.state.selectedRow.dealer,
                city: this.state.selectedRow.city,
                userId: "" + this.state.selectedRow.userId,
                toolbox: this.state.selectedRow.toolbox,
                toolboxId: this.state.selectedRow.toolboxId,
                firstVisit: this.state.selectedRow.firstVisit,
                completionOn: this.state.selectedRow.completionOn,
                createdBy: this.state.selectedRow.createdBy,
                status: this.state.selectedRow.status,
                reminderOn: this.state.selectedRow.reminderOn,
                userMdl: this.props.user.userMdl,
                nmscCode: this.props.user.userMdl.nmsc,
                langCode: this.props.user.userMdl.lang,
                loginId: this.props.user.userMdl.username,
                updatedTimestampStr: this.state.selectedRow.updatedTimestampStr,
                // updateViewed:this.state.selectedRow.updateViewed,
            },
            translatedStatus: I18n.t(this.state.selectedRow.status),  
            translateDate:I18n.t(this.state.selectedRow.completionOn
            )      
        });
    }



 
    backToActivity = () => {
       // console.log("this.props.location.query.searchCriteria",this.props.location.query.searchCriteria);
        if (this.props.location.query.searchCriteria.program) {
            this.props.dispatch(searchActivity(this.props.location.query.searchCriteria));
            this.props.dispatch(
                push({
                    pathname: "/activity",
                    query: { activityDto: this.props.location.query.searchCriteria }
                })
            );
        }
        else {
            this.props.dispatch(
                push({pathname: "/certification"})
            );
        }
    }
    
    render() {
        console.log("translatedStatus", this.state.translatedStatus)
        const isNAS = this.props.user?.userMdl?.activeProgram === "NAS";
        const isFirstAuditLaunched = this.props.activityDetailsData;
        const firstVisitAfterFirstAudit = moment(isFirstAuditLaunched?.firstVisit).format("DD/MM/YYYY");
        const completionDateAfterFirstAudit = moment(isFirstAuditLaunched?.completionOn).format("DD/MM/YYYY");
        let accessType = '';
        let isEvaluationAccessible = false;
        if (this.props.user.userMdl && this.props.user.userMdl.accessControl) {
            accessType = this.props.user.userMdl.accessControl.filter(obj => obj.function === 'DOWNLOAD_Q')[0] ? this.props.user.userMdl.accessControl.filter(obj => obj.function === 'DOWNLOAD_Q')[0].accessType : null
        }
        
        if (this.props.user.userMdl && this.props.user.userMdl.accessControl) {
            isEvaluationAccessible = this.props.user.userMdl.accessControl.filter(obj => obj.function === 'ACTIVITY_EVALUATION')[0] && (this.props.user.userMdl.activeProgram === "TSM" ||  this.props.user.userMdl.activeProgram === "NAS" || this.props.user.userMdl.activeProgram === "TSM_BNP" || this.props.user.userMdl.activeProgram === "TSM_USED_CAR" || this.props.user.userMdl.activeProgram === "TSM_SURVEYS")? true : false
            console.log(isEvaluationAccessible );
        }



        //this.props.user.userMdl.accessControl.filter(obj => obj.function === 'DOWNLOAD_Q')[0].accessType;
        // let toolbox = this.state.selectedActivity.toolbox;
        let iconClass = "_icon";
        var srt =this.state.toolboxLocation;
        srt=srt.replace(/\//g, '$');
        srt = srt.replace(/\./g, '_red*');
        return (
            <div className="activityDiv">
                <Container className={"b-1 actionPlanContainer actionPlanContainer-" + this.props.theme.name}
                    style={{ minHeight: "70em", backgroundColor: "rgba(247, 247, 247, 1)" }}>
                    <Row className="activityTabsHeaderRed">
                        <Col md="6" style={{ fontSize: "20px", textTransform: 'uppercase' }}>{this.state.selectedRow.dealer}</Col>
                        <Col md="1"></Col>
                        <Col md="5">
                            <div style={{ paddingLeft: "3rem", float: "right", fontSize: "20px", fontWeight: "bold" }}>
                                <img src={baseUrl + srt} style={{ marginRight: "5px"}} className={iconClass} alt=""/>
                                {this.state.selectedRow.toolbox}
                            </div></Col>
                    </Row>
                    <Row className="activityTabsHeader pl-5 pr-5" >
                        <Col md="1">{I18n.t('Table.city')}</Col>
                        <Col md={isNAS ? 1 : 2}>{I18n.t('Table.assignee')}</Col>
                        <Col md={isNAS ? 1 : 2}>{I18n.t('Table.createdBy')}</Col>
                        {isNAS && <Col md="2">{I18n.t('Table.FirstAuditBy')}</Col>}
                        {isNAS && <Col md="2">{I18n.t('Table.ReEvaluationBy')}</Col>}
                        <Col md="1">{I18n.t('Table.startDate')}</Col>
                        <Col md={isNAS ? 1 : 2}>{I18n.t('Table.completionDate')}</Col>
                        <Col md="1">{I18n.t('Table.status')}</Col>
                        <Col md="1">{I18n.t('Table.updatedOn')}</Col>
                       
                    </Row>
                    <Row className="selectedCriteria activityTabsHeader pl-5 pr-5">
                        <Col md="1">{this.state.selectedRow.city}</Col>
                        <Col md={isNAS ? 1 : 2}>{this.state.selectedRow.assignee}</Col>
                        <Col md={isNAS ? 1 : 2}>{this.state.selectedRow.createdBy}</Col>
                        {isNAS && <Col md="2">{isFirstAuditLaunched?.firstAuditLaunchBy ? isFirstAuditLaunched?.firstAuditLaunchBy : '-'}</Col>}
                        {isNAS && <Col md="2">{isFirstAuditLaunched?.reAuditLaunchedBy ? isFirstAuditLaunched?.reAuditLaunchedBy : '-'}</Col>}
                        <Col md="1">{isFirstAuditLaunched?.firstAuditLaunchBy ? firstVisitAfterFirstAudit : this.state.selectedRow.firstVisit}</Col>
                        <Col md={isNAS ? 1 : 2}>{isFirstAuditLaunched?.firstAuditLaunchBy ? completionDateAfterFirstAudit : this.state.translateDate}</Col>
                        <Col md="1">{this.state.translatedStatus}</Col>
                        <Col md="1">{this.state.selectedRow.updatedTimestampStr}</Col>
                        <Col md="1" float="right">
                            {(this.state.selectedRow.status === "Planned" || this.state.selectedRow.status === "Closed" ||
                                this.state.selectedRow.status === "Ongoing") && accessType === "R/W" ?
                                <a onClick={() => this.toggleModal("Edit")} style={{ float: "right" }}><div title={I18n.t('tmeAdminMaster.edit')} className="edit-icon-white" /></a> : ""}
                        </Col>
                    </Row>
                    
                    <Col md="12" className="activityTabs mt-2">
                        {( this.state.isNmsc===true )?this.state.selectedRow.updateViewed && this.state.selectedRow.updateViewed!==null && this.state.selectedRow.updateViewed==="Y" && this.state.selectedRow.actionPlanUpdated!=="True" &&  this.state.selectedRow.kpiUpdated!=="True" && this.state.selectedRow.questionnaireUpdated!=="True" ?    <i class="fa fa-check " alt="Back"   style={{float:"right" ,width:"3%",height:"3%",color:"green"}}></i>:<i class="fa fa-check " alt="Back" onClick={()=>this.viewStatus(this.state.selectedRow)}  style={{float:"right" ,width:"3%",height:"3%",color:"red"}} ></i>:" "}
                 
                        {(this.state.selectedRow.toolboxId === 1) ?
                            !isEvaluationAccessible ?
                                <Tabs onSelect={this.selectedTab} selected={this.state.selectedTab}>
                                    <Tab label={this.labelForActionPlan()}>
                                        <ActionPlanTable activity={this.state.selectedRow} searchCriteria={this.props.location.query.searchCriteria} 
                                         parentComponent={"actionPlan"}/>
                                    </Tab>
                                </Tabs> :
                                <Tabs onSelect={this.selectedTab} selected={this.state.selectedTab}>
                                    <Tab label={this.labelForQuestionnaire()} >
                                        <Evaluation
                                            toolbox={this.state.selectedRow.toolboxId}
                                            selectTab={this.selectedTab}
                                            activityId={this.state.selectedActivity.activityId} activityStatus={this.state.selectedRow.status} firstAudit ={this.state.selectedRow.firstAudit}/>
                                        <hr />

                                        <img src={'images/back-' + this.props.theme.name + '.png'} alt="Back" onClick={this.backToActivity} style={{ cursor: "pointer" }} />


                                    </Tab>
                                    <Tab label={this.labelForActionPlan()} >

                                        <ActionPlanTable activity={this.state.selectedRow} searchCriteria={this.props.location.query.searchCriteria} 
                                         parentComponent={"actionPlan"}/>
                                    </Tab>

                                   
                                </Tabs>
                                
                                 :
                                 
                            isEvaluationAccessible?
                            this.props.user.userMdl.activeProgram ==="NAS"?
                                <Tabs onSelect={this.selectedTab} selected={this.state.selectedTab}>
                                    <Tab label={this.labelForKpi()}> 
                                        <ActionKPITable activity={this.state.selectedRow} selectedActivity={this.state.selectedActivity} searchCriteria={this.props.location.query.searchCriteria} />
                                  
                                        </Tab>
                                       <Tab  label={this.labelForQuestionnaire()} > 
                                        <Evaluation
                                            toolbox={this.state.selectedRow.toolboxId}
                                            selectTab={this.selectedTab}
                                            activityId={this.state.selectedActivity.activityId} activityStatus={this.state.selectedRow.status} />
                                        <hr />

                                        <img src={'images/back-' + this.props.theme.name + '.png'} alt="Back" onClick={this.backToActivity} style={{ cursor: "pointer" }} />

                                    </Tab>
                                    <Tab label={this.labelForActionPlan()}>
                                    <div>
                                  <KaizenSection
                                            toolbox={this.state.selectedRow.toolboxId}
                                            selectTab={this.selectedTab}
                                            activityId={this.state.selectedActivity.activityId} activityStatus={this.props.activityDetailsData?.status} />
                                     
                                    </div>
                                        {/* <ActionPlanTable activity={this.state.selectedRow} searchCriteria={this.props.location.query.searchCriteria} 
                                         parentComponent={"actionPlan"}/> */}
                                    </Tab>

                                        <Tab label={I18n.t("dashboardCards.ReAudit")}>
                                            {/* Content for Reevaluation */}
                                            <Reevaluation
                                                toolbox={this.state.selectedRow.toolboxId}
                                                selectTab={this.selectedTab}
                                                activityId={this.state.selectedActivity.activityId} activityStatus={this.state.selectedRow.status} />
                                                <hr />
                                                <img src={'images/back-' + this.props.theme.name + '.png'} alt="Back" onClick={this.backToActivity} style={{ cursor: "pointer" }} />
                                        </Tab>
                                </Tabs> :
                                <Tabs onSelect={this.selectedTab} selected={this.state.selectedTab} >
                                  
                                    <Tab label={this.labelForKpi()}> 
                                        <ActionKPITable activity={this.state.selectedRow} selectedActivity={this.state.selectedActivity} searchCriteria={this.props.location.query.searchCriteria} />
                                  
                                        </Tab>
                                        
                                    <Tab  label={this.labelForQuestionnaire()} > 
                                        <Evaluation
                                            toolbox={this.state.selectedRow.toolboxId}
                                            selectTab={this.selectedTab}
                                            activityId={this.state.selectedActivity.activityId} activityStatus={this.state.selectedRow.status} />
                                        <hr />

                                        <img src={'images/back-' + this.props.theme.name + '.png'} alt="Back" onClick={this.backToActivity} style={{ cursor: "pointer" }} />

                                    </Tab>
                                    <Tab label={this.labelForActionPlan()}>
                                        <ActionPlanTable activity={this.state.selectedRow} searchCriteria={this.props.location.query.searchCriteria} 
                                         parentComponent={"actionPlan"}/>
                                    </Tab>

                                       
                                </Tabs> :   
                                <Tabs onSelect={this.selectedTab} selected={this.state.selectedTab}>
                                          {/* <Tab  label={this.labelForQuestionnaire()} > 
                                        <Evaluation
                                            toolbox={this.state.selectedRow.toolboxId}
                                            selectTab={this.selectedTab}
                                            activityId={this.state.selectedActivity.activityId} activityStatus={this.state.selectedRow.status} />
                                        <hr />

                                        <img src={'images/back-' + this.props.theme.name + '.png'} alt="Back" onClick={this.backToActivity} style={{ cursor: "pointer" }} />

                                    </Tab> */}
                                    {/* Kpi section for Brit added*/}
                                    <Tab label={this.labelForKpi()} >
                                        <ActionKPITable activity={this.state.selectedRow} selectedActivity={this.state.selectedActivity} searchCriteria={this.props.location.query.searchCriteria} />

                                    </Tab>
                                    <Tab label={this.labelForActionPlan()}>
                                        <ActionPlanTable activity={this.state.selectedRow} searchCriteria={this.props.location.query.searchCriteria} 
                                         parentComponent={"actionPlan"}/>
                                    </Tab>
             
                                </Tabs>}

                    </Col>
                    {this.state.modal === true ?
                        <ActivityModal
                            modal={this.state.modal}
                            goTo="actionPlan"
                            toggle={this.toggleModal}
                            modalFor={this.state.modalFor}
                            selectedRow={this.state.selectedRow}
                            activityDto={this.props.location.query.searchCriteria} /> : null}
                </Container>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        user: state.loginReducer,
        blocking: state.loginReducer,
        router: state.routing,
        fileName: state.tabReducer.fileName,
        selectedRow: state.activityReducer.selectedRow,
        activityDetailsData: state.evaluationReducer.activityDetails
    }
}
export default withRouter(connect(mapStateToProps)(withTheme(ActionPlan)));